var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 67,
    height: 64,
    viewBox: "0 0 67 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.41;fill:url(#a);}.b{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 1.24,
    y1: -0.141,
    x2: -0.073,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#246bc5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-723 -1797)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 67,
    height: 64,
    transform: "translate(790 1861) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 44,
    height: 42,
    transform: "translate(734 1808)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard2);
export default __webpack_public_path__ + "static/media/card2.1145daf723e436ff245649684f5e3ec0.svg";
export { ForwardRef as ReactComponent };